module.exports = __webpack_public_path__ + "static1710991110236-0.0.5.6/img/zzb-B.7657fe30.png";